// company bank details form used in setting>General>Organization
import { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { useDispatch } from "react-redux";
import { createStyles, makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { UpdateCompanyConfigurationAction } from "../../../../../store/Ancillary/CompanyDetails/Action";

const CompanyBankDetails = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { company_config_data, configLoading } = useSelector(
    (state) => state?.AncillaryReducer?.CompanyConfigReducer,
  );

  const [bankData, setBankData] = useState({
    account_number: "",
    account_type: "",
    account_holder: "",
    bank_branch: "",
    ifsc_code: "",
    bank_name: "",
  });

  const [errors, setErrors] = useState({});

  const account_type_options = [
    { id: "1", name: "Savings Account" },
    { id: "2", name: "Current Account" },
  ];

  const [accountType, ] = useState({
    load: false,
    values: account_type_options,
  });
  // ---------------- VALIDATION ----------------
  const validate = (fieldValues) => {
    let temp = { ...errors };

    if ("account_number" in fieldValues) {
      temp.account_number =
        !fieldValues.account_number
          ? ""
          : fieldValues.account_number.match(/^[0-9]{9,16}$/)
            ? ""
            : "Invalid Account Number";
    }
    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  // ---------------- INPUT CHANGE ----------------
  const handleInputChange = (event, value) => {
    if (["account_type"].includes(event)) {
      setBankData({
        ...bankData,
        [event]: value || "",
      });

      if (Object.values(errors).some((x) => x !== "")) {
        validate({ ...bankData, [event]: value });
      }
    } else {
      const { name, value } = event.target;

      setBankData({
        ...bankData,
        [name]: name === "ifsc_code" ? value.toUpperCase() : value,
      });

      if (Object.values(errors).some((x) => x !== "")) {
        validate({
          ...bankData,
          [event.target.name]: event.target.value,
        });
      }
    }
  };

  // ---------------- SUBMIT ----------------
  const handleSubmit = (e) => {
    if (validate(bankData)) {
      dispatch(
        UpdateCompanyConfigurationAction({
          ...company_config_data,
          bank_details_json: JSON.stringify(bankData),
        }),
      );
    }
  };

  useEffect(() => {
    company_config_data?.bank_details &&
      setBankData({ ...company_config_data?.bank_details });
  }, [company_config_data]);
  return (
    <Paper className={classes.Paper}>
      <Backdrop className={classes.Backdrop} open={configLoading}>
        <CircularProgress />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Account Number"
              name="account_number"
              value={bankData.account_number}
              type={"number"}
              onChange={handleInputChange}
              autoFocus
              {...(errors.account_number && {
                error: true,
                helperText: errors.account_number,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Account Holder Name"
              name="account_holder"
              value={bankData.account_holder}
              onChange={handleInputChange}
              {...(errors.account_holder && {
                error: true,
                helperText: errors.account_holder,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Bank Name"
              name="bank_name"
              value={bankData.bank_name}
              onChange={handleInputChange}
              {...(errors.bank_name && {
                error: true,
                helperText: errors.bank_name,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Bank Branch"
              name="bank_branch"
              value={bankData.bank_branch}
              onChange={handleInputChange}
              {...(errors.bank_branch && {
                error: true,
                helperText: errors.bank_branch,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="IFSC Code"
              name="ifsc_code"
              value={bankData.ifsc_code}
              onChange={handleInputChange}
              {...(errors.ifsc_code && {
                error: true,
                helperText: errors.ifsc_code,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <SelectableSearch
              label="Account Type"
              value={bankData.account_type}
              fieldLabel="name"
              variant="outlined"
              name="account_type"
              size="small"
              onChangeEvent={handleInputChange}
              data={accountType}
              {...(errors.account_type && {
                error: true,
                helperText: errors.account_type,
              })}
            />
          </FormControl>
        </Grid>

        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            className="mpl-primary-btn"
            sx={{ mt: 2 }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};
const useStyles = makeStyles((theme) =>
  createStyles({
    Paper: {
      boxShadow:
        theme.palette.mode === "dark"
          ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
          : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
      padding: "40px 40px 20px 40px",
      borderRadius: "16px",
      backgroundColor: "#f3edfd",
      position: "relative",
    },
    Backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      position: "absolute",
      borderRadius: "inherit",
    },
  }),
);

export default CompanyBankDetails;
